var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_307_5490)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5534 9.15431C16.5534 8.47831 16.4986 7.98501 16.3799 7.47345H8.66064V10.5246H13.1917C13.1003 11.2828 12.607 12.4247 11.5108 13.192L11.4954 13.2942L13.9361 15.1849L14.1052 15.2018C15.6582 13.7676 16.5534 11.6573 16.5534 9.15431Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66062 17.1932C10.8804 17.1932 12.744 16.4624 14.1052 15.2018L11.5108 13.192C10.8165 13.6762 9.88471 14.0142 8.66062 14.0142C6.48646 14.0142 4.64117 12.58 3.98338 10.5977L3.88696 10.6058L1.34911 12.5699L1.31592 12.6622C2.66791 15.3479 5.44501 17.1932 8.66062 17.1932Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.98326 10.5978C3.80969 10.0862 3.70924 9.53805 3.70924 8.9717C3.70924 8.40528 3.80969 7.85719 3.97413 7.34563L3.96953 7.23668L1.39987 5.24106L1.3158 5.28105C0.758578 6.39555 0.438843 7.6471 0.438843 8.9717C0.438843 10.2963 0.758578 11.5478 1.3158 12.6623L3.98326 10.5978Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66062 3.92902C10.2044 3.92902 11.2458 4.59589 11.8396 5.15317L14.16 2.88763C12.7349 1.56303 10.8804 0.75 8.66062 0.75C5.44501 0.75 2.66791 2.59529 1.31592 5.28101L3.97424 7.34559C4.64117 5.36326 6.48646 3.92902 8.66062 3.92902Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_307_5490"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.1238,
    height: 16.5,
    fill: "white",
    transform: "translate(0.43811 0.75)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/GOOGLE.6ed31638a77c1d1af645ee95e5e4ec71.svg";
export { ForwardRef as ReactComponent };